export const css = {
	root: '_3aK_luCp',
	assess_card: '_1hj9ryMG',
	title: '_3s3pYh14',
	actions: 'WL1aKDEc',
	' _key': 'afcpe-theme/afcpe/explore-view/nav-card'
};

export default css;
